import { Component } from '@angular/core';

@Component({
  selector: 'app-card-monitoraggio',
  templateUrl: './card-monitoraggio.component.html',
  styleUrls: ['./card-monitoraggio.component.css']
})
export class CardMonitoraggioComponent {

}
